import React from 'react'
import { connect } from 'react-redux'
import CookingBackground from '../../images/background_cooking_icons.png'
import { QueryParams } from '../';
import { Zoom } from 'react-reveal';
import { paramsToObject } from '../../Utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SocialMediaIcons from '../SocialMediaIcons'
import { GoBackButton } from '../'
import style from './style.module.scss'

const SingleRecipe = (props) => {
    const { recipe = {} } = props;
    const {
        name = 'N/A',
        photos = [],
        ready_in,
        directions = 'No Directions Available',
        ingredients = 'No Ingredients Available'
    } = recipe
    const { location = '' } = photos[0] || {}

    return (
        <div className={style.container}>
            <div className={style.buttonWrapper}>
                <GoBackButton label="Go Back" />
            </div>
            <Zoom top>
                <div className={style.recipeImage}>
                    {location && <img src={location} />}
                </div>
            </Zoom>
            <div className={style.recipeHeader}>
                <Zoom left>
                    <span className={style.recipeName}>{name}</span>
                </Zoom>
                {ready_in &&
                    <span className={style.recipeLength}>
                        <Zoom bottom>  <FontAwesomeIcon className={style.stopwatch} icon={"stopwatch"} /></Zoom>
                        <Zoom right><span className={style.recipeTime}>{ready_in}</span></Zoom>
                    </span>}
            </div>
            <div className={style.instructionsWrapper} style={{ backgroundImage: `url(${CookingBackground})` }}>

                <div className={style.ingredients}> <Zoom top><span className={style.title}>INGREDIENTS</span></Zoom>
                    <Zoom left>
                        <span className={style.ingredientsCopy}>{ingredients}</span>
                    </Zoom>
                    <div className={style.socialMediaSection}>
                        <Zoom left>    <span className={style.socialMediaHeader}>Follow our recipes on Social Media!</span></Zoom>
                        <Zoom bottom>  <SocialMediaIcons /></Zoom>
                    </div>
                </div>
                <Zoom right>
                    <div className={style.method}>
                        <span className={style.title}>METHOD</span>
                        <span className={style.methodCopy}>
                            {directions}
                        </span>
                    </div>
                </Zoom>
                <div className={`${style.socialMediaSection} ${style.socialMediaSectionBottom}`}><Zoom right>
                    <span className={style.socialMediaHeader}>Follow our recipes on Social Media!</span></Zoom>
                    <Zoom bottom>
                        <SocialMediaIcons /></Zoom>
                </div>
            </div>
        </div>
    )
}

export default connect((state) => {
    const { search } = window.location;
    const params = paramsToObject(search);
    const viewedRecipe = state.recipes.find(r => r.id === +params.id)
    return ({
        recipe: viewedRecipe
    })
})(QueryParams(SingleRecipe))